import React from 'react'
import Flipcard from '../../../components/landingPage/Flipcards/FullBgFlipcard'
import Section from '../../landingPage/Section'
import styled from "styled-components";
import {PatHighPrecision, PatExcellentAesthetics, PatMinimallyInvasive, PatEasierAffordable, PatOralHealth, PatConnectivity, PatComfortEfficiency, PatConsistentPredictable, PatDDDChairside,} from '../../../images/index'

function PatientBenefits() {
  
  const flipcards = [
    {
      id: 1,
      image: PatHighPrecision,
      title: "High Precision",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:2,
      image: PatExcellentAesthetics,
      title:"Excellent Aesthetics",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:3,
      image: PatMinimallyInvasive,
      title:"Minimally Invasive",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:4,
      image: PatEasierAffordable,
      title:"Easier & Affordable",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:5,
      image: PatComfortEfficiency,
      title:"Comfort & Efficiency",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:6,
      image: PatOralHealth,
      title:"Oral Health",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:7,
      image: PatConnectivity,
      title:"Connectivity My XiViX Platform",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:8,
      image: PatConsistentPredictable,
      title:"Consistent & Predictable",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:9,
      image: PatDDDChairside,
      title:"XiViX Chairside solutions",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    }
  ]


  return (
    <div>
      <Section title="Patient Benefits" className="mb-10 lg:mb-20 px-0 sm:px-4 2xl:px-20" id="PatientBenefits">
        <div className="overflow-x-auto flex flex-row justify-between lg:mx-20 gap-2 lg:gap-0 2xl:gap-4">
          {flipcards.map(flipcard => {
            return (
              <Flipcard flipcard={flipcard} key={flipcard.id}/>
            )
          })}
        </div>
      </Section>
    </div>
  )
}

export default PatientBenefits
